import { Component, h } from 'preact';
import { getKey, Key, Properties, TravelClass, WidgetTab } from '../../common';
import Selector from '../../common/Selector/Selector';
import { BookingState, connectStore } from '../../store';
import { stopPropagation } from '../../utils';
import TravelClassModal from './TravelClassModal/TravelClassModal';
import { FinText } from '../../i18n';

interface StoreProps {
  travelClass: TravelClass;
  disabled: boolean;
}

const mapStateToProps = ({ selection: { travelClass }, currentTab }: BookingState): StoreProps => ({
  travelClass: currentTab === WidgetTab.AM ? TravelClass.MIXED : travelClass,
  disabled: currentTab === WidgetTab.AM,
});

export interface TravelClassSelectorProps extends Properties {}

type EffectiveProps = TravelClassSelectorProps & StoreProps;

@connectStore({ mapStateToProps })
export default class TravelClassSelector extends Component<TravelClassSelectorProps> {
  openModal = (e: Event): void => {
    stopPropagation(e);
    const { disabled } = this.props;
    if (!disabled) {
      this.context.modal.showModal(<TravelClassModal />);
    }
  };

  handleKeyUp = (e: KeyboardEvent): void => {
    const key: Key = getKey(e);
    if (key === Key.ENTER || key === Key.SPACE) {
      this.openModal(e);
    }
  };

  render({ travelClass, disabled }: EffectiveProps): h.JSX.Element {
    return (
      <Selector class={this.props.class} onClick={this.openModal} onKeyUp={this.handleKeyUp} disabled={disabled}>
        <div class="grey-600-text font-body-1 regular-type">
          <FinText id="travelClassSelector.title" />
        </div>
        <div className={`medium-type font-heading-5 ${disabled ? 'grey-600-text' : 'nordic-blue-900-text'}`}>
          <FinText id={`travelClass.${travelClass}`} />
        </div>
      </Selector>
    );
  }
}
